export enum DeleteVersionType {
  mapped_events = 'mapped_events',
  metrics = 'metrics',
  custom_dimension = 'custom_dimension',
  flow = 'flow',
}
export interface IBulkActionProps {
  resource: DeleteVersionType;
  loading?: boolean;
  data?: any[];
  onClose?: () => void;
  show?: boolean;
}

export interface IPromptProps {
  actionType: string | null;
  resource: string;
  requestStatus: 'success' | 'failure' | null;
  onTryAgain?: () => void;
  onCancel?: () => void;
  data?: any[];
}
